import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {HashLink as NavLink} from 'react-router-hash-link';
import './Nav.css';
import Follow from '../../global/follow/Follow.jsx';
import Home from '../../../views/home/Home.jsx';


import * as Scroll from 'react-scroll';

let Element = Scroll.Element;

/**
 * Nav - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Nav extends Component {

  /**
   * Default props
   *
   * A view object property may contain the following properties:
   *  name - The text that will be displayed.
   *  url - Can be an internal or external link.  The component will handle each accordingly.
   *  component - The view component for the page, e.g. Home, About, Contact
   *  active - Whether or not the name text will be an active link or just static text.
   *
   * @type {{navList: Array}}
   */
  static defaultProps = {
    navList: [
      {
        name: 'Home',
        url: '/',
        component: Home,
        active: true
      }
    ]
  };

  /**
   * Prop Types
   *
   * @type {{}}
   */
  static propTypes = {
    navList: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      component: PropTypes.func.isRequired,
      active: PropTypes.bool
    })).isRequired
  };

  /**
   * State
   *
   * @type {{links: Array}}
   */
  state = {
    inputChecked: false,
    isMobile: false,
    links: []
  };


  constructor(props) {
    super(props);

    this.linkClicked = this.linkClicked.bind(this);
  }


  /**
   * Component will receive props
   *
   * Note - links need to be nested arrays but routes need to be a flat array.
   *
   * @param nextProps
   */
  componentDidMount() {
    const {navList} = this.props;

    let isMobile = false;

    if (window.innerWidth < 1000) {
      isMobile = true;
    }

    let links = navList.map(function (view, index) {

      if (view.url === this.props.location.pathname) {
        view.className = 'active';
      } else {
        view.className = '';
      }

      if (view.subMenu !== undefined) {
        let link = this.createLink(view);

        let subMenuLinks = view.subMenu.map(function (subMenuView, index) {
          return <li key={index}>{this.createLink(subMenuView)}</li>
        }, this);

        return <li key={index}>{link}
          <ul className={view.listClass}>{subMenuLinks}</ul>
        </li>;

      } else {
        return <li key={index}
                   className={view.className}>{this.createLink(view)}</li>
      }
    }, this);

    this.setState({
      links: links,
      isMobile: isMobile
    });
  }

  /**
   * Create link
   *
   * @param view
   * @returns {XML}
   */
  createLink(view) {
    if (view.active !== undefined && view.active === false) {
      return view.name;
    }

    if (view.url.indexOf('http') !== -1) {
      return <a target="_blank"
                href={view.url}>{view.name}</a>;
    }

    if (view.url.indexOf('#') !== -1) {
      return <Element name={view.name}><a href={view.url}
                                          onClick={this.linkClicked}>{view.name}</a></Element>
    } else {
      return <Element name={view.name}><NavLink to={view.url}
                                                onClick={this.linkClicked}>{view.name}</NavLink></Element>;
    }
  }

  /**
   * Link clicked.
   *
   * @param event
   */
  linkClicked(event) {
    if (this.state.isMobile === true) {
      this.setState({
        inputChecked: false
      });
    }
  }

  /*
   * Render
   *
   * @returns {XML}
   */
  render() {
    const {links} = this.state;

    return (
      <nav className="Nav">

        {/*CSS-ONLY TRIGGER HAMBURGER*/}
        <input
          type="checkbox"
        />

        {/*HAMBURGER*/}
        <span className="Hamburger"/>
        <span className="Hamburger"/>
        <span className="Hamburger"/>

        {/*MENU*/}
        <ul id="menu">
          {links}
          <Follow facebookUrl="https://www.facebook.com/SoleroFruitBar/"
                  instagramUrl="https://www.instagram.com/solerofruitbar/"
                  twitterVisible={false}/>
        </ul>


      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/global/nav/Nav.jsx